import { get, keyBy, sortBy } from 'lodash';

// CREW-1240 — one JR collection (`vacancy_contacts`) read from two sides.
// The owner card needs the employee's `status` and `phone` next to the name:
// the backend skips deactivated people and people with no phone when it
// builds an ad, and the list has to show why a ticked person is not going to
// appear rather than drop them silently.

export const keyIncluded = (included = []) => keyBy(included, ({ type, id }) => `${type}:${id}`);

const relationId = (row, name) => get(row, `relationships.${name}.data.id`, null);

export const rowForOwner = (row, included) => {
  const clientId = relationId(row, 'client');
  const client = included[`clients:${clientId}`];

  return {
    id: row.id,
    clientId,
    name: get(client, 'attributes.name', null),
    status: get(client, 'attributes.status', null),
    phone: get(client, 'attributes.phone', null),
  };
};

export const rowForClient = (row, included) => {
  const ownerId = relationId(row, 'owner');
  const owner = included[`owners:${ownerId}`];

  return {
    id: row.id,
    ownerId,
    name: get(owner, 'attributes.title', null),
    shortName: get(owner, 'attributes.short_title', null),
  };
};

export const forOwner = ({ data, included }) => {
  const grouped = keyIncluded(included);
  return sortBy(data.map((row) => rowForOwner(row, grouped)), 'name');
};

export const forClient = ({ data, included }) => {
  const grouped = keyIncluded(included);
  return sortBy(data.map((row) => rowForClient(row, grouped)), 'name');
};
